import { Link } from "react-router-dom";

import { Spinner } from "@/components/Spinner";
import { useAuth } from "@/auth/AuthProvider";
import { useTabs } from "./TabsContext";

/**
 * Gate a page on having at least one connected tab. If none exist, direct the
 * viewer to /admin/tabs so a superadmin can create one.
 */
export function RequireTab({ children }: { children: React.ReactNode }) {
  const { tabs, isLoading, isError, currentTab } = useTabs();
  const { me } = useAuth();
  const isSuper = me?.role === "super_admin";

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Spinner label="Loading tabs…" />
      </div>
    );
  }
  if (isError) {
    return (
      <div className="min-h-screen flex items-center justify-center p-8">
        <div className="alert-danger">Failed to load tabs.</div>
      </div>
    );
  }
  if (tabs.length === 0) {
    return (
      <div className="min-h-screen flex items-center justify-center p-8">
        <div className="card max-w-md p-6 space-y-3 text-center">
          <h2 className="text-lg font-semibold">No exam tabs connected yet.</h2>
          <p className="text-sm text-slate-500 dark:text-slate-400">
            {isSuper
              ? "Create a tab to connect this app to a govt SQL Server."
              : "Ask a superadmin to create a tab for the exam you support."}
          </p>
          {isSuper && (
            <Link to="/admin/tabs" className="btn-primary inline-flex">
              Manage tabs
            </Link>
          )}
        </div>
      </div>
    );
  }
  if (!currentTab) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Spinner label="Selecting tab…" />
      </div>
    );
  }
  return <>{children}</>;
}
